// Header.js 
import { useRefs } from '../../context/RefContext';
import './Header.scss';
import { Link , useNavigate } from 'react-router-dom';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import brandLogo from '../../images/trimmed_logo.png'; 



const Header = ({ titleLine1, titleLine2, description, button }) =>
{
    //const { indexRef } = useRefs();
    const { indexRef, companyRef, handleScrollTo } = useRefs();
    useEffect(() =>
    {
        Aos.init({ duration: 1000, once: true });
    }, []);

    const navigate = useNavigate();

    const handleLinkClick = (path, ref) =>
    {
        //setMenuOpen(false);
        navigate(path);
        if (ref)
        {
            setTimeout(() =>
            {
                handleScrollTo(ref);
            }, 300); // espera un poco para que la navegación se complete
        }
    };
    
  return (
    <div className='header' ref={indexRef}>
      <div className="header_container">
        <div className="header_text_container">
          <div className="header_text" data-aos="fade-right">
            <h1>
              {titleLine1 && <span className="title-line-1">{titleLine1}</span>}
              {titleLine2 && <span className="title-line-2">{titleLine2}</span>}
            </h1>

            {description && <p className='open_sans'>{description}</p>}
            {false && <button className='open_sans'>                   <Link
                            to="/"
                            className='open_sans'
                            onClick={() => handleLinkClick('/', companyRef)}>
                            {button}
                        </Link></button>}
            </div>
            <div className="header_logo_container" data-aos="fade-left">
                <img src={brandLogo} alt="The Cosmic Shores Brand Logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;

